export const optedOutDealerIds: number[] = [
    7247, 19752, 5158, 72933, 25031, 40383, 59753, 106550, 106548, 34501
];

export const autocoachActieSearchFilters: Record<string, any> = {
    carrosserievormen: [
        "HATCHBACK",
        "STATIONWAGEN",
        "MPV",
        "SEDAN",
        "SUV",
        "BEDRIJFSWAGEN",
        "CABRIOLET",
        "COUPE",
        "PERSONENBUS",
        "PICK_UP",
        "OVERIG"
    ],
    maximumprijs: 60000,
    minimumprijs: 5000,
    soortAanbieder: [
        "MERKDEALER_GEKOZEN_MERK",
        "OFFICIELE_MERKDEALER",
        "SUBDEALER",
        "BOVAG_AUTOBEDRIJF",
        "UNIVERSEEL_AUTOBEDRIJF"
    ]
};
